import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { Row, Col, Form, Input, Button, Typography, message } from 'antd'
import { ROW_JUSTIFY, COL_SPAN } from '../common/const'
import {
  CheckSystem,
  getRedirectUrl,
  OpenBrowserUrl,
  addUrlParam,
  openRedirectUrl,
} from '../common/globalFun'
import { useIntl } from 'react-intl'

import HeaderLogo from '../components/HeaderLogo'
import PageBg from '../components/PageBg'

import './css/style.css'

const { Title } = Typography

const Download = (props) => {
  const intl = useIntl()

  const [loading, setLoading] = useState(true)

  const download = () => {
    window.location.href = 'https://felo.me/download'
  }

  const loginClient = () => {
    const scheme = 'felo://login?token=' + props.loginKey
    window.location.href = scheme
  }

  const loginWeb = () => {
    OpenBrowserUrl(getRedirectUrl())
  }

  const login = () => {
    setLoading(true)
    setTimeout(() => {
      setLoading(false)
    }, 1000 * 10)
    if (props.redirectUri && props.loginKey) {
      const newHref = addUrlParam(props.redirectUri, {
        loginKey: props.loginKey,
      })
      openRedirectUrl(newHref)
    } else {
      if (CheckSystem.Felo()) {
        if (props.loginKey) {
          loginClient()
        } else {
          message.error('The login key is missing. Please login again')
          setTimeout(() => {
            setLoading(false)
          }, 1000 * 1)
        }
      } else {
        loginWeb()
      }
    }
  }

  useEffect(() => {
    login()
  }, [])

  return (
    <>
      <PageBg />
      <Row
        justify={ROW_JUSTIFY}
        align="middle"
        className={`height-full download-page`}
      >
        <Col span={COL_SPAN}>
          <section className={`hd-section createTeamHead`}>
            <HeaderLogo />
            <Title className="mt-30" level={2}>
              {intl.formatMessage({ id: 'download.title' })}
            </Title>
          </section>
          <section className="mt-50">
            <div className="btn-max-width margin-center">
              <Button
                block
                loading={loading}
                type="primary"
                size="large"
                onClick={login}
                g-action="continueToFelo"
                g-category="login"
              >
                {intl.formatMessage({ id: 'continue.felo' })}
              </Button>
            </div>

            <div className="content-center mt-30">
              <Button type="link" size="large" onClick={download}>
                {intl.formatMessage({ id: 'download.felo.app' })}
              </Button>

              <div className="mt-10">
                <span>{intl.formatMessage({ id: 'app.installed' })}</span>

                <Button
                  className="padding-0"
                  type="link"
                  size="middle"
                  onClick={loginClient}
                >
                  {intl.formatMessage({ id: 'app.open' })}
                </Button>
              </div>
            </div>
          </section>
        </Col>
      </Row>
    </>
  )
}

const stateProps = (state) => {
  return {
    loginKey: state.loginKey,
    redirectUri: decodeURIComponent(state.redirectUri),
  }
}

export default connect(stateProps)(Download)
